module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_6005.7f9d616e.png";